import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight
import {
  Email
} from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import apilink from "../globals/Baseurls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

const Register = () => {
  const [email, setEmail] = useState("");
  const [posting, setPosting] = useState(false);
  const navigate = useNavigate();

  const handleProceed = () => {
    if (email === "") {
      toast.warn("Failed. Fill in your email or phone", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    setPosting(true);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+/;
    const phoneRegexLocal = /^07/; // e.g.,0 7 7 3 2 2 8 8 2 9
    const phoneRegexIntl = /^2637/; // e.g.,2 6 3 7 7 3 2 2 8 8 2 9

    if (emailRegex.test(email)) {

      const regData = {
        "identifier": email,
        "id_type": "email"
      }

      localStorage.setItem("userReg", JSON.stringify(regData));
      setPosting(false);
      navigate("/email-register");
      return;
    }

    if (phoneRegexLocal.test(email)) {
      if (email.length != 10) {
        setPosting(false);
        toast.warn("Failed. Please provide a valid phone number", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      } else {
        const regData = {
          "identifier": email,
          "id_type": "phone"
        }

        localStorage.setItem("userReg", JSON.stringify(regData));
        setPosting(false);
        navigate("/phone-register");
        return;
      }
    } else if (phoneRegexIntl.test(email)) {
      if (email.length != 12) {
        setPosting(false);
        toast.warn("Failed. Please provide a valid phone number", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      } else {
        const regData = {
          "identifier": email,
          "id_type": "phone"
        }

        localStorage.setItem("userReg", JSON.stringify(regData));
        setPosting(false);
        navigate("/phone-register");
        return;
      }
    } else {
      setPosting(false);
      toast.warn("Failed. Fill in a valid email or phone", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
  };

  const handleMemberSignIn = () => {
    navigate("/");
  };

  return (
    <>
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "76px",
          paddingInline: 30,
        }}
      >
        <img
          alt="logo"
          style={{ width: "100px", height: "80px", resizeMode: "stretch" }}
          src={require("./logo.png")}
        />
        <h1
          className="navbar-brand mb-0"
          style={{ fontFamily: "Caveat", fontSize: 38 }}
        >
          <b>Collide - </b> Dating
        </h1>
        <p
          style={{
            color: "#010832",
            fontFamily: "Open Sans",
            marginTop: "80px",
          }}
        >
          New Account Registration
        </p>
        <p
          style={{
            color: "#00000090",
            fontFamily: "Open Sans",
            marginTop: "10px",
            fontSize: "12px"
          }}
        >
          <center>
            Enter a valid email or phone number to register. <br />You will receive a one-time confirmation code <br />(OTP) to proceed to the next step
          </center>
        </p>
        <div
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#010832",
            backgroundColor: "#010832",
            borderRadius: 5,
            height: 50,
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div style={{
            width: "40px",
            height: 50,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}>
            <Email style={{ color: "#ffffff" }} />
          </div>
          <div style={{
            height: 50,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}>
            <input
              style={{
                height: 48.2,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: 'none',

              }}
              value={email}
              placeholder="Email or phone"
              onChange={(e) => { setEmail(e.target.value) }}
            />
          </div>
          <div></div>
        </div>

        <button
          onClick={() => handleProceed()}
          style={{
            width: "320px",
            backgroundColor: "#010832",
            borderRadius: 5,
            border: "none",
            height: 50,
            fontFamily: "Open Sans",
            fontSize: 14,
            color: "white",
            marginTop: "10px",
          }}
        >
          {posting === false && <>Continue</>}
          {posting && (
            <>
              <Squares />
            </>
          )}
        </button>


        <p
          onClick={() => handleMemberSignIn()}
          style={{
            color: "#000000",
            fontFamily: "Open Sans",
            fontSize: 14,
            marginTop: "20px",
            alignSelf: "left",
            width: "320px",
          }}
        >
          Already registered &nbsp;?&nbsp; <span style={{ color: "#010832" }}>Click here to login</span>
        </p>

        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </>
  );
};

export default Register;
